
export function formatPrice(price: number | string): string {

  let output = typeof(price) === 'number' ? price.toFixed(2) : price

  if (output.match(/\.00$/)) {
    output = output.substring(0, output.length - 3)
  }

  return output
}